// Samuel speech→tract model (3.4M params, ONNX export of hf:vvolhejn/samuel), run in a Web Worker.
import { SAMPLE_RATE, FRAME_RATE } from './samuelCore';

const SR = SAMPLE_RATE;
export { SAMPLE_RATE, FRAME_RATE };

let worker = null, wid = 0;
const pending = new Map();
const call = (msg) => {
  if (!worker) {
    worker = new Worker(new URL('./samuel.worker.js', import.meta.url));
    worker.onmessage = ({ data }) => {
      const p = pending.get(data.id); if (!p) return;
      pending.delete(data.id);
      if (data.error) p.reject(new Error(data.error)); else p.resolve(data.result);
    };
    worker.onerror = (e) => { pending.forEach((p) => p.reject(new Error(e.message || 'Samuel worker error'))); pending.clear(); worker = null; loadP = null; };
  }
  const id = ++wid;
  return new Promise((resolve, reject) => { pending.set(id, { resolve, reject }); worker.postMessage({ id, ...msg }); });
};

let loadP = null;
export const loadModel = () => {
  if (!loadP) loadP = call({ type: 'load' }).catch((e) => { loadP = null; throw e; });
  return loadP;
};

// Returns { samuel, analysis } computed off the main thread.
export const imitate = async (wav) => { await loadModel(); return call({ type: 'imitate', wav }); };

// Any audio Blob/ArrayBuffer → mono Float32 at 44.1 kHz.
export const decodeTo44k = async (input) => {
  const buf = input instanceof Blob ? await input.arrayBuffer() : input;
  const tmp = new (window.OfflineAudioContext)(1, SR, SR);
  const audio = await tmp.decodeAudioData(buf.slice(0));
  const off = new OfflineAudioContext(1, Math.ceil(audio.duration * SR), SR);
  const src = off.createBufferSource(); src.buffer = audio; src.connect(off.destination); src.start();
  return (await off.startRendering()).getChannelData(0).slice();
};
